import { HttpRequest, HttpErrorResponse, HttpEvent, HttpResponseBase, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { InAppMessageService } from '../services/in-app-message.service';
import { SlackMessagingService } from '../services/slack-messaging.service';

const sendDebugMessage = (injector: Injector, response: HttpResponseBase, request: HttpRequest<any>) => {
  if (!environment.production && request.urlWithParams !== environment.slackMsg) {
    injector.get(SlackMessagingService).sendErrorMsg(request.urlWithParams, [
      {
        author_name: '',
        color: 'danger',
        title: 'Debugging',
        text:
          `========== Body ==========${JSON.stringify(request.body)}\n` + `========== Response ==========` + `\n${JSON.stringify(response)}`
      }
    ]);
  }
};

const handleData = (injector: Injector, response: HttpResponseBase, request: HttpRequest<any>): Observable<any> => {
  switch (response.status) {
    case 200:
      break;
    case 401:
      Preferences.clear();
      console.log(response);
      if (response instanceof HttpErrorResponse) {
        if (response.error.result && response.error.result.error) {
          switch (response.error.result.error) {
            case 'error.incorrect.username.or.password':
              injector.get(InAppMessageService).simpleToast(response.error.result.error);
              break;
          }
        }
      }
      return throwError(() => response);
      break;
    case 403:
      injector.get(InAppMessageService).simpleToast('error.403');
      return throwError(() => response);
      break;
    case 0:
      // this.inAppMessageService.simpleToast('error.request.cancelled');
      return throwError(() => response);
      break;
    default:
      if (response instanceof HttpErrorResponse) {
        sendDebugMessage(injector, response, request);
        if (response.error.result && response.error.result.error) {
          switch (response.error.result.error) {
            case 'error.submit.too.often':
              break;
            case 'error.transaction.has.been.flagged':
              break;
            case 'error.duplicate.submit':
              break;
            default:
              injector.get(InAppMessageService).simpleToast(response.error.result.error);
              break;
          }
        }
        return throwError(() => response);
      }
      break;
  }
  return of(response);
};

export const appInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const injector = inject(Injector);
  // 统一加上服务端前缀
  let url = req.url;
  if (!url.startsWith('https://') && !url.startsWith('http://') && !url.startsWith('assets/')) {
    url = environment.API_URL + url;
  }

  const newReq = req.clone({
    url,
    headers: req.headers.set('Accept', 'application/json')
  });

  return next(newReq).pipe(
    mergeMap((event: any) => {
      // 统一对请求response处理
      if (event instanceof HttpResponseBase) {
        return handleData(injector, event, newReq);
      }
      // 若一切都正常，则后续操作
      return of(event);
    }),
    catchError((err: HttpErrorResponse) => handleData(injector, err, newReq))
  );
};
